import { createFragmentContainer } from "react-relay";

// components
import { AutopilotFlexibility as AutopilotFlexibilityCommons } from "@clockwise/web-commons/src/ui/autopilot-flexibility";

// internal
import { fragments } from "./AutopilotFlexibility.gql";

///////////
// Relay //
///////////

export const AutopilotFlexibility = createFragmentContainer(AutopilotFlexibilityCommons, fragments);
